import { render, staticRenderFns } from "./AudioPreview.vue?vue&type=template&id=0a0f53c8&scoped=true&"
import script from "./AudioPreview.vue?vue&type=script&lang=js&"
export * from "./AudioPreview.vue?vue&type=script&lang=js&"
import style0 from "./AudioPreview.vue?vue&type=style&index=0&id=0a0f53c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0f53c8",
  null
  
)

export default component.exports